<template>
  <v-container class="login">
    <v-layout wrap justify-center style="" class="text-xs-center align-content-center">
      <v-flex xs12 sm6 md4 style="box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.381) ; border-radius: 10px;" class="pl-4 pr-4 pb-4">
    <img src="../assets/logo_dbc.png" alt="" width="200px" class="pt-4">
    <v-form class="text-xs-center align-content-center">

          <v-text-field           
           v-model="email"
           label="Email"   
            
          ></v-text-field>
              <v-text-field 
          v-model="password" label="Password" type="password"
           
          ></v-text-field>

    </v-form>
    <v-btn @click="login" color="success">Login</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login(){
    firebase.auth().signInWithEmailAndPassword(this.email, this.password)
    .then(
        (user) => {
          this.$router.replace('/dashboard')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      );
    }
  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .login {
    margin-top: 40px;
        margin-left: auto;
    margin-right: auto;
   
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }

 
</style>